<div class="row">
    <otb-inner-breadcrumb
        *otbShowInEnv="['default', 'justice', 'finance', 'sh', 'hmdj', 'bb-jm']"
    ></otb-inner-breadcrumb>
    <otb-progress-bar></otb-progress-bar>
</div>

@if (hasAppointments) {
    <div class="row">
        <div class="col-12">
            <h2
                [innerHTML]="'dynamische_frontend_texte.zeit_auswahl.html_content.ueberschrift' | translate | safeStyle"
            ></h2>
        </div>

        @if (!showFormSwitcherTop) {
            <div class="col-12 mb-5">
                <div class="changeform__container">
                    <a
                        (click)="switchToDateFirst($event)"
                        href="#"
                        class="changeform has--before-arrow"
                        title="{{
                            'dynamische_frontend_texte.datum_auswahl.attribute_text.suche_fuer_bestimmtes_datum'
                                | translate
                        }}"
                        [innerHTML]="
                            'dynamische_frontend_texte.datum_auswahl.html_content.suche_fuer_bestimmtes_datum'
                                | translate
                                | safeStyle
                        "
                    >
                    </a>
                </div>
            </div>
        }
        <div class="col-12 col-sm-6" [class.d-none]="timesLoading">
            <otb-time-pick-selection
                [dateFirst]="false"
                [availableAgencies]="times"
                (timeSelect)="onTimeSelect($event)"
            ></otb-time-pick-selection>
        </div>
        <!-- Die Statusbereiche bleiben im DOM, sonst meldet der Screenreader ihren Inhalt nicht -->
        <div class="col-12 col-sm-6 mb-5" [class.d-none]="!timeChosen">
            <div class="upper__container mb-5 mb-sm-2" role="status" aria-atomic="true">
                @if (timeChosen) {
                    <p
                        class="mb-0"
                        [innerHTML]="
                            'dynamische_frontend_texte.zeit_auswahl.html_content.auswahl'
                                | translate
                                | replaceDateTime: selectedTimeDateFormat
                                | async
                        "
                    ></p>
                }
            </div>
            <div
                #calendarContainer
                [class.colorblind-active]="colorLegendShow | async"
                [class.d-none]="timesLoading || calendarLoading"
            >
                <input type="hidden" #datepicker />
            </div>
            @if (timeChosen && calendarLoading) {
                <div class="loading--text">
                    <otb-loading-animation-dots
                        [text]="'dynamische_frontend_texte.lade_animation.kalender'"
                    ></otb-loading-animation-dots>
                </div>
            }
            @if (!showFormSwitcherTop) {
                <div class="col-12 mb-5">
                    <div class="changeform__container">
                        <a
                            (click)="switchToDateFirst($event)"
                            href="#"
                            class="changeform has--before-arrow"
                            title="{{
                                'dynamische_frontend_texte.datum_auswahl.attribute_text.suche_fuer_bestimmtes_datum'
                                    | translate
                            }}"
                            [innerHTML]="
                                'dynamische_frontend_texte.datum_auswahl.html_content.suche_fuer_bestimmtes_datum'
                                    | translate
                                    | safeStyle
                            "
                        >
                        </a>
                        <fa-icon class="fa" [icon]="faArrowCircleRight"></fa-icon>
                    </div>
                </div>
            }
            <otb-color-legend [class.d-none]="timesLoading || calendarLoading"></otb-color-legend>
            <!-- only relevant for time first -->
            <div class="mt-4" role="status" aria-atomic="true">
                @if (dateChosen | async) {
                    <p class="selected-date mb-0">
                        <span
                            [innerHTML]="
                                'dynamische_frontend_texte.zeit_auswahl.html_content.wunschtermin'
                                    | translate
                                    | safeStyle
                            "
                        ></span>
                        <span class="fw-bold"> {{ selectedDate | date: 'dd.MM.yyyy' }}, {{ selectedTime?.time }}</span>
                    </p>
                }
            </div>
        </div>
        <div class="loading--text col-6" [class.d-none]="!timesLoading"></div>
    </div>
} @else {
    <div class="row">
        <div class="col-12">
            <p
                class="info__header"
                [innerHTML]="
                    'dynamische_frontend_texte.datum_auswahl.html_content.ueberschrift_keine_termine'
                        | translate
                        | safeStyle
                "
            ></p>
            <p
                class="info__content"
                [innerHTML]="
                    'dynamische_frontend_texte.datum_auswahl.html_content.naechste_freie_termine'
                        | translate
                        | replaceDateTime: nextAppointmentAt
                        | async
                "
            ></p>
        </div>
    </div>
}
@if (timesLoading) {
    <div class="row">
        <div class="col-12">
            <otb-loading-animation-dots
                [text]="'dynamische_frontend_texte.lade_animation.zeiten'"
            ></otb-loading-animation-dots>
        </div>
    </div>
}

<div class="row">
    <div class="form-group d-flex justify-content-between flex-md-row flex-column mt-4 gap-2">
        <otb-back-button></otb-back-button>

        @if (dateChosen | async) {
            <div
                class="d-flex flex-column flex-md-row align-items-md-center justify-content-md-end gap-3 order-md-2 order-1"
            >
                <button
                    type="submit"
                    class="btn-success btn m-0 mb-3 mb-sm-0"
                    accesskey="w"
                    btnPrimaryColorDirective
                    (click)="submit()"
                    [innerHTML]="'dynamische_frontend_texte.shared.button.next' | translate | safeStyle"
                ></button>
            </div>
        }
    </div>
</div>
